import React, { useState, useEffect } from "react";
import { Card, Row, Col, Button, Form, Modal, Accordion, Tabs, Tab, Nav, Offcanvas } from "react-bootstrap";
import Select from "react-select";
import moment from "moment";
import Center from "react-center";
import * as Icons from "react-feather";

export default function Step1Page(props) {
  const {
    dataStep1,
    setDataStep1,
    fetchSelectorUnit,
    selectorUnit,
    loadingUnit,
    handleNext,
    setUnitJenis3,
    selectorRS,
    loadingPengumuman,
  } = props;

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [showUnitDateModal, setShowUnitDateModal] = useState(false);
  const [showRegistrationModal, setShowRegistrationModal] = useState(false);
  const [visitDate, setVisitDate] = useState("");
  const [selectedSBU, setSelectedSBU] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState(null);
  const isFormValid = dataStep1?.unit && dataStep1?.date;
  const [modalHistory, setModalHistory] = useState([]);


  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (showModal && selectedMenu?.label === "Daftar Online") {
      setShowUnitDateModal(true);
      setShowModal(false);
      setModalHistory(["unitDate"]);
    }
  }, [showModal, selectedMenu]);

  useEffect(() => {
    if (showRegistrationModal) {
      setShowUnitDateModal(false); 
      setModalHistory(["registration"]);
    }
  }, [showRegistrationModal]);  
  

  const selectorSBU = [
    { value: "RSPG", label: "Rumah Sakit Petrokimia Gresik", location: "https://goo.gl/maps/Kaugv4ev8JbqkSDr7", img: "assets/img/rspg.png", profile: "Rumah Sakit Petrokimia Gresik adalah rumah sakit yang menyediakan layanan kesehatan lengkap dan berkualitas." },
    { value: "GRAHU", label: "Rumah Sakit Grha Husada", location: "https://goo.gl/maps/YtnjVQkmEX7m9tXD9", img: "assets/img/rsgh.png", profile: "Rumah Sakit Grha Husada menawarkan berbagai layanan medis dengan fasilitas modern." },
    { value: "DRIYO", label: "RSPG Driyorejo", location: "https://goo.gl/maps/RCTEzS4JEMgRGNwt8", img: "assets/img/rspgd.png", profile: "RSPG Driyorejo adalah rumah sakit dengan berbagai layanan kesehatan untuk masyarakat." },
    { value: "PPK1", label: "Klinik PPK I PT Petrokimia Gresik", location: "https://goo.gl/maps/4xYCCL2nRrFaBq9k9", img: "assets/img/logoppk.png", profile: "Klinik PPK I PT Petrokimia Gresik memberikan layanan kesehatan bagi karyawan dan masyarakat sekitar." },
    { value: "KALIMANTAN", label: "Klinik Satelit Kalimantan", location: "https://goo.gl/maps/9pMZG3iPkkdbD5o88", img: "assets/img/logosatkal.png", profile: "Klinik Satelit Kalimantan menyediakan layanan kesehatan dasar dan spesialis." },
    { value: "WA", label: "Klinik PPK I Wringinanom Gresik", location: "https://goo.gl/maps/cDmnMQjzbGARio539", img: "assets/img/logoppk.png", profile: "Klinik PPK I Wringinanom Gresik menyediakan layanan kesehatan dasar dan spesialis." },
  ];

  let hariIni = moment().format("YYYY-MM-DD");
  let maxHari =
    dataStep1?.sbu === "RSPG" && dataStep1.unit !== "P37"
      ? moment().add(30, "days").format("YYYY-MM-DD")
      : dataStep1?.sbu === "RSPG" && dataStep1.unit === "P37"
      ? moment().add(5, "days").format("YYYY-MM-DD")
      : moment().add(3, "days").format("YYYY-MM-DD");

      const handleHospitalSelect = (sbu) => {
        setSelectedSBU(sbu);
        fetchSelectorUnit(sbu.value);
        setDataStep1({ ...dataStep1, sbu: sbu.value, sbuname: sbu.label, unit: null, unitname: null });
        setShowUnitDateModal(true);
      };

      const handleUnitSelect = (e) => {
        setDataStep1({ ...dataStep1, unit: e.value, unitname: e.label });
        setUnitJenis3(e.jenis3);
      };

      const handleDateSelect = () => {
        setDataStep1({ ...dataStep1, visitDate: visitDate });
        setShowUnitDateModal(false);
        setShowRegistrationModal(true);
        setModalHistory(["registration"]);
      };      

      const handleRegistrationModalClose = (registered) => {
        setDataStep1({ ...dataStep1, rs: registered ? "Pernah" : "Belum" });
        setShowRegistrationModal(false);
        setModalHistory([]);
        handleNext();
      };      
    
      const handleSelect = (sbu) => {
        setSelectedSBU(sbu);
        setShowModal(true);
      };


  return (
    <>
      <Card.Title className="text-center">
        <strong>Pilih Unit Rawat Jalan & Tanggal Kunjungan</strong>
      </Card.Title>
      <br />

      {isMobile ? (
        /** === Mobile / Tablet Small View === */
        <>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Unit Rawat Jalan Tujuan</Form.Label>
            <Select
              styles={{ zIndex: 99999 }}
              id="unit"
              name="unit"
              options={selectorUnit.filter((unit) => unit.value !== "pilih_unit_tujuan")}
              isLoading={loadingUnit}
              value={selectorUnit.find((find) => find?.value === dataStep1?.unit)}
              onChange={handleUnitSelect}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Tanggal Kunjungan</Form.Label>
            <Form.Control
              type="date"
              id="tanggal"
              name="tanggal"
              value={dataStep1?.date}
              onChange={(e) =>
                setDataStep1({ ...dataStep1, date: e.target.value })
              }
              min={moment().add(0, "days").format("YYYY-MM-DD")}
              max={
                dataStep1?.sbu === "RSPG" && dataStep1.unit !== "P37"
                  ? moment().add(30, "days").format("YYYY-MM-DD")
                  : dataStep1?.sbu === "RSPG" && dataStep1.unit === "P37"
                  ? moment().add(5, "days").format("YYYY-MM-DD")
                  : moment().add(3, "days").format("YYYY-MM-DD")
              }
            />
          </Form.Group>
          <br />
          <div className="text-center">
          <Button
              variant="warning"
              onClick={handleDateSelect}
              style={{ width: "100%" }}
              disabled={!isFormValid}
            >
              Lanjutkan
            </Button>
          </div>
          </Form>
      </>
      ) : (
        /** === Desktop / Tablet Large View === */
        <>
          <Card.Title>
            <Row>
              <Col lg={5} md={5} sm={12}>
                <strong>(1/4) Pilih Tujuan dan Tanggal</strong>
              </Col>
            </Row>
          </Card.Title>
          <br />
          <Row>
            <Col className="d-none d-md-block" lg={5} md={5}>
              <Center>
                <img src="assets/img/medic-1.svg" width="100%" alt="gambar" />
              </Center>
            </Col>
            <Col lg={7} md={7} sm={12}>
              <Form>
                <Form.Group className="mb-3">
                  <Form.Label>Rumah Sakit / Klinik Tujuan</Form.Label>
                  <Select
                    styles={{
                      color: "black",
                    }}
                    id="sbu"
                    name="sbu"
                    options={selectorSBU}
                    value={selectorSBU.find(
                      (find) => find?.value === dataStep1?.sbu
                    )}
                    onChange={(e) => {
                      fetchSelectorUnit(e.value);
                      setDataStep1({
                        ...dataStep1,
                        sbu: e.value,
                        sbuname: e.label,
                        unit: null,
                        unitname: null,
                      });
                    }}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Unit Rawat Jalan Tujuan</Form.Label>
                  {dataStep1?.sbu !== null ? (
                    <Select
                      styles={{
                        color: "black",
                        zIndex: 99999,
                      }}
                      id="unit"
                      name="unit"
                      options={selectorUnit}
                      isLoading={loadingUnit}
                      value={selectorUnit.find(
                        (find) => find?.value === dataStep1?.unit
                      )}
                      onChange={(e) => {
                        setDataStep1({
                          ...dataStep1,
                          unit: e.value,
                          unitname: e.label,
                          rs: e.value === "P37" ? "Pernah" : null,
                        });
                        setUnitJenis3(e.jenis3);
                      }}
                    />
                  ) : (
                    <Form.Control
                      type="text"
                      value="Pilih Rumah Sakit / Klinik Tujuan Terlebih Dahulu..."
                      disabled
                    />
                  )}
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Tanggal</Form.Label>
                  <Form.Control
                    type="date"
                    id="tanggal"
                    name="tanggal"
                    value={dataStep1?.date}
                    onChange={(e) =>
                      setDataStep1({ ...dataStep1, date: e.target.value })
                    }
                    min={moment().add(0, "days").format("YYYY-MM-DD")}
                    max={
                      dataStep1?.sbu === "RSPG" && dataStep1.unit !== "P37"
                        ? moment().add(30, "days").format("YYYY-MM-DD")
                        : dataStep1?.sbu === "RSPG" && dataStep1.unit === "P37"
                        ? moment().add(5, "days").format("YYYY-MM-DD")
                        : moment().add(3, "days").format("YYYY-MM-DD")
                    }
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Pernah Berobat ke RSPG Group (RSPG,RS Grha Husada, RSPG
                    Driyorejo, Klinik Satelit Kalimantan, Klinik PPK I Ahmad Yani,
                    Klinik PPK I Wringinanom)?
                  </Form.Label>
                  <Select
                    styles={{
                      color: "black",
                    }}
                    id="rs"
                    name="rs"
                    options={selectorRS}
                    isDisabled={dataStep1?.unit === "P37"}
                    value={selectorRS.find((find) => find?.value === dataStep1?.rs)}
                    onChange={(e) => {
                      setDataStep1({
                        ...dataStep1,
                        rs: e.value,
                      });
                    }}
                  />
                </Form.Group>
                <br />
                <Button
                  style={{ float: "right" }}
                  variant="primary"
                  disabled={
                    dataStep1?.sbu === null ||
                    dataStep1?.unit === null ||
                    dataStep1?.date === null ||
                    dataStep1?.rs === null ||
                    dataStep1?.rs === "" ||
                    dataStep1?.date < hariIni ||
                    dataStep1?.date > maxHari ||
                    moment(dataStep1.date).isValid() === false ||
                    loadingPengumuman
                  }
                  onClick={() => {
                    handleNext();
                  }}
                >
                  {loadingPengumuman ? "...Loading" : "Simpan & Lanjutkan"}
                  <Icons.ArrowRight size={18} />
                </Button>
              </Form>
            </Col>
          </Row>
        </>
      )}

      <Modal show={showRegistrationModal} onHide={() => setShowRegistrationModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Registrasi</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Apakah Anda sudah pernah mendaftar sebelumnya?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleRegistrationModalClose(false)}>
            Belum Pernah
          </Button>
          <Button variant="primary" onClick={() => handleRegistrationModalClose(true)}>
            Sudah Pernah
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}